import * as React from 'react';
import { Button, Alert, Col, Tooltip, OverlayTrigger } from 'react-bootstrap';

import MapService from '../../../features/map/MapService';
import AddressMap from './AddressMap';
import ICoordinate from '../../../features/map/ICoordinate';
import { Translate } from '../../../shared/LanguageService';

interface IProps {
    addressLine: string;
    onAddressLineChange: (addressLine: string) => void;
    postalNumber: string;
    onPostalNumberChange: (postalNumber: string) => void;
    city: string;
    onCityChange: (city: string) => void;
    point: ICoordinate;
    onPointChange: (point: ICoordinate) => void;
    onValidationChange?: (isValid: boolean) => void;
    error: string;
}

interface IState {
    isAdressValid: boolean;
    showAddressMap: boolean;
    pointAddress: google.maps.GeocoderResult;
    isValidatingAddress: boolean;
    noManuellAddressPoint: boolean;
}

class AddressMapButton extends React.Component<IProps, IState> {
    private geoCheckingTimer = null;

    constructor(props: IProps) {
        super(props);

        this.state = {
            isAdressValid: false,
            showAddressMap: false,
            pointAddress: null,
            isValidatingAddress: false,
            noManuellAddressPoint: false
        };

        this.onAdressChange = this.onAdressChange.bind(this);
        this.openAddressMap = this.openAddressMap.bind(this);
        this.save = this.save.bind(this);
        this.clearPointAddress = this.clearPointAddress.bind(this);
        this.changeValidation = this.changeValidation.bind(this);
    }

    componentDidMount() {
        if (!this.state.isValidatingAddress) {
            this.onAdressChange(
                this.props.point,
                this.props.addressLine,
                this.props.postalNumber,
                this.props.city
            );
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (
            JSON.stringify(nextProps.point) !== JSON.stringify(this.props.point) ||
            nextProps.addressLine !== this.props.addressLine ||
            nextProps.postalNumber !== this.props.postalNumber ||
            nextProps.city !== this.props.city
        ) {
            this.onAdressChange(
                nextProps.point,
                nextProps.addressLine,
                nextProps.postalNumber,
                nextProps.city
            );
        }
    }

    onAdressChange(
        point: ICoordinate,
        addressLine: string,
        postalNumber: string,
        city: string
    ): void {
        if (point && !this.state.noManuellAddressPoint) {
            this.changeValidation(true);
            this.save(point);
        } else if (addressLine && postalNumber && city) {
            if (this.geoCheckingTimer) {
                clearTimeout(this.geoCheckingTimer);
            }

            this.props.onPointChange(null);
            this.geoCheckingTimer = setTimeout(() => {
                this.setState({ isValidatingAddress: true } as IState);
                this.props.onPointChange(null);

                MapService.getAddress(addressLine, postalNumber, city)
                    .then((result: google.maps.GeocoderResult) => {
                        if (result) {
                            this.changeValidation(true);
                        } else {
                            this.changeValidation(false);
                        }

                        this.setState({
                            isValidatingAddress: false,
                            noManuellAddressPoint: false
                        } as IState);
                    })
                    .catch(() => {
                        this.setState({
                            isValidatingAddress: false,
                            noManuellAddressPoint: false
                        } as IState);
                        this.changeValidation(false);
                    });
            }, 1000);
        } else {
            this.changeValidation(false);
        }
    }

    openAddressMap() {
        this.setState({ showAddressMap: true } as IState);
    }

    save(position: ICoordinate) {
        MapService.getAddresFromPosition(position.longitude, position.latitude).then(
            (result: google.maps.GeocoderResult) => {
                let coordniate: ICoordinate = null;
                if (result) {
                    if (position) {
                        this.props.onPointChange(position);
                    }

                    let route = result.address_components.filter(
                        (x) => x.types.indexOf('route') > -1
                    );
                    let streetNumber = result.address_components.filter(
                        (x) => x.types.indexOf('street_number') > -1
                    );
                    let postalNumber = result.address_components.filter(
                        (x) => x.types.indexOf('postal_code') > -1
                    );
                    let city = result.address_components.filter(
                        (x) => x.types.indexOf('postal_town') > -1
                    );

                    if (!this.props.addressLine && !this.props.postalNumber && !this.props.city) {
                        if (result.address_components) {
                            let address = '';
                            if (route.length > 0) {
                                address += route[0].long_name;
                            }

                            if (streetNumber.length > 0) {
                                address += ' ' + streetNumber[0].long_name;
                            }
                            if (address) {
                                this.props.onAddressLineChange(address);
                            }

                            if (postalNumber.length > 0) {
                                this.props.onPostalNumberChange(postalNumber[0].long_name);
                            }

                            if (city.length > 0) {
                                this.props.onCityChange(city[0].long_name);
                            }
                        }

                        this.setState({ noManuellAddressPoint: false } as IState);
                    }
                    if (
                        this.props.addressLine ===
                            this.getFirstLongNameOrDefault(route) +
                                ' ' +
                                this.getFirstLongNameOrDefault(streetNumber) &&
                        this.props.postalNumber === this.getFirstLongNameOrDefault(postalNumber) &&
                        this.props.city === this.getFirstLongNameOrDefault(city)
                    ) {
                        this.setState({ noManuellAddressPoint: true } as IState);
                    }

                    this.setState({ pointAddress: result } as IState);
                }

                this.setState({ showAddressMap: false } as IState);
            }
        );
    }

    getFirstLongNameOrDefault(list: google.maps.GeocoderAddressComponent[]) {
        if (list.length > 0) {
            return list[0].long_name;
        }

        return null;
    }

    clearPointAddress() {
        this.setState({ pointAddress: null } as IState);
        this.props.onPointChange(null);
    }

    changeValidation(isValid: boolean) {
        if (this.props.onValidationChange) {
            this.props.onValidationChange(isValid);
        }

        this.setState({ isAdressValid: isValid } as IState);
    }

    getLocationIcon() {
        if (this.state.isValidatingAddress) {
            return <i className="load-spin-dark"></i>;
        } else if (this.state.pointAddress && this.state.noManuellAddressPoint === false) {
            return <i className="material-icons location-edit">edit_location</i>;
        } else if (this.state.isAdressValid) {
            return <i className="material-icons location-ok">location_on</i>;
        } else {
            return <i className="material-icons location-error">location_off</i>;
        }
    }

    render() {
        return (
            <span>
                <Col xs={1} className="location-icon">
                    <OverlayTrigger
                        placement="right"
                        overlay={
                            <Tooltip id="location-tooltip">
                                {Translate('address/custom/button/title')}
                            </Tooltip>
                        }
                    >
                        <span
                            disabled={this.state.isValidatingAddress}
                            onClick={this.openAddressMap}
                        >
                            {this.getLocationIcon()}
                        </span>
                    </OverlayTrigger>
                </Col>
                {this.state.pointAddress && this.state.noManuellAddressPoint === false && (
                    <Col xs={12}>
                        <Alert bsStyle="info" onDismiss={this.clearPointAddress}>
                            <h4>{Translate('address/custom/alert/heading')}</h4>
                            {this.state.pointAddress.formatted_address}
                        </Alert>
                    </Col>
                )}
                {this.props.error && (
                    <div className="form-group has-error">
                        <span className="help-block">{this.props.error}</span>
                    </div>
                )}

                {this.state.showAddressMap && (
                    <AddressMap
                        addressLine={this.props.addressLine}
                        postalNumber={this.props.postalNumber}
                        city={this.props.city}
                        point={this.props.point}
                        save={this.save}
                        close={() => this.setState({ showAddressMap: false } as IState)}
                    />
                )}
            </span>
        );
    }
}

export default AddressMapButton;
